import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'NOTICE_UPDATE',
    smsDelete : 'NOTICE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        notice: [],

        submitSuccess: false,
        noticeLoading: false,
        noticeError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_NOTICE(state, notice) {
            state.notice = notice;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        NOTICE_LOADING (state, loading) {
            state.noticeLoading = loading;
        },

        NOTICE_ERROR (state, hasError) {
            state.noticeError = hasError;
        }
    },

    actions: {
        async addNotice ({commit, dispatch}, payload) {
            commit('NOTICE_LOADING', true);
            commit('NOTICE_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_notice, payload.notice, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchNotice')
                return response

            } catch (e) {
                commit('NOTICE_ERROR', true);
            } finally {
                commit('NOTICE_LOADING', false);
            }
        },

        async fetchNotice ({ commit }) {
            commit('NOTICE_LOADING', true);
            commit('NOTICE_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.notice_list, config);
                let response = result.data.data
                commit('SET_NOTICE', response);
                return result
            } catch(error) {
                commit('NOTICE_ERROR', true);
            } finally {
                commit('NOTICE_LOADING', false);
            }
        },

        async updateNotice ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_notice + payload.id, payload.notice, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchNotice')
                return response

            } catch (e) {
                commit('NOTICE_ERROR', true);
            } finally {
                commit('NOTICE_LOADING', false);
            }
        },

        async deleteNotice({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_notice + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchNotice')
            return response
        }
    },

    getters: {}
}
